package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_02_14_Day_1
import com.veldekar.components.logs.Log_2026_02_14_Day_2
import com.veldekar.components.logs.Log_2026_02_14_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-02-14")
@Composable
public fun Log_2026_02_14(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "A Bastion to Restore, A Ship to Board",
        ogTitle = "A Bastion to Restore, A Ship to Board",
        date = LocalDate(2_026, 2, 14),
        ogDescription = "Paperwork signed, pirate hats donned, and Bigglesworth declaring, “Fish make strong. Oatmeal make… face sad.”",
        ogImage = "images/bigglesworthCatchesFish_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "An animated LEGO scene showing a cat-like character (representing Bigglesworth) interacting with a LEGO ship and catching a fish.",
    ) {
        SessionDayHeader(dayId = "shimmer-10", dateString = "Shimmer 10")
        Log_2026_02_14_Day_1()
        SessionDayHeader(dayId = "shimmer-11", dateString = "Shimmer 11")
        Log_2026_02_14_Day_2()
        SessionDayHeader(dayId = "shimmer-12", dateString = "Shimmer 12")
        Log_2026_02_14_Day_3()
        SessionMediaItem(
            image = "images/bigglesworthCatchesFish.gif",
            linkImage = "images/bigglesworthCatchesFish.gif",
            description = "An animated LEGO scene showing a cat-like character (representing Bigglesworth) interacting with a LEGO ship and catching a fish.",
            width = 1_210,
            height = 907,
        )
    }
}
